import { motion } from "framer-motion";
import { useReducedMotion } from "framer-motion";

// Transição editorial entre rotas: fade + slide de 8px em 240ms.
export const PageTransition = ({ children }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.24, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
